import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionTag } from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const KindChip = ({ kind }) => (
  <span
    className={`font-mono text-[9px] tracking-[0.25em] px-2 py-1 border ${
      kind === "TARGET" ? "border-polar/60 text-polar" : "border-gold/60 text-gold"
    }`}
  >
    {kind}
  </span>
);

export default function UpdatesPreview() {
  const [updates, setUpdates] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/updates`)
      .then((r) => setUpdates(r.data.slice(0, 3)))
      .catch(() => setUpdates([]));
  }, []);

  return (
    <section id="updates-preview" data-testid="updates-preview-section" className="relative py-24 lg:py-32">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-8 lg:px-12">
        <Reveal>
          <SectionTag index="09" label="Mission Updates" />
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
            <h2 className="font-display font-bold uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl text-ice leading-[0.95]">
              Dispatches from <span className="text-polar">development</span>
            </h2>
            <Link
              to="/updates"
              data-testid="updates-full-page-btn"
              className="group inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-polar hover:text-ice transition-colors duration-300 shrink-0"
            >
              All mission updates
              <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </div>
          <p className="mt-5 max-w-2xl text-sm text-ice/55 leading-relaxed">
            Clearly labelled concept notes only. No invented expedition milestones, no fabricated scientific
            discoveries — genuine field results will be published if the mission eventually occurs.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-14">
          {updates.map((u, i) => (
            <Reveal key={u.id} delay={0.08 * i}>
              <Link to="/updates" className="block group h-full" data-testid={`updates-card-${i + 1}`}>
                <article className="border border-polar/15 bg-[#0B1F35]/80 p-7 h-full flex flex-col group-hover:border-polar/45 transition-colors duration-300">
                  <div className="flex items-center justify-between gap-3">
                    <KindChip kind={u.kind} />
                    <span className="font-mono text-[10px] text-tech tracking-widest">{u.date}</span>
                  </div>
                  <h3 className="font-display font-semibold text-xl text-ice mt-5 tracking-wide leading-tight group-hover:text-polar transition-colors duration-300">
                    {u.title}
                  </h3>
                  <p className="text-sm text-ice/60 mt-3 leading-relaxed flex-1">{u.summary}</p>
                  <div className="mt-6 font-mono text-[10px] tracking-[0.25em] text-tech uppercase">{u.category}</div>
                </article>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
